(function($) {
  "use strict";

  jQuery(document).ready(function(){
    
    
    /*-------------------------
      main-menu active
    --------------------------*/
    $('.main-menu nav').meanmenu({
      meanScreenWidth: "991",
      meanMenuContainer: '.mobile-menu'
    });

    /*-------------------------
      search active
    --------------------------*/
    $(".icon-search").on("click", function() {
      $(this).parent().find('.toogle-content').slideToggle('medium');
    })


    /*-------------------------
      slider active
    --------------------------*/
    $('.slider-active').owlCarousel({
      loop: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      items: 1,
      dots: false,
      nav: true,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })
    
    $('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});

    /*-------------------------
      product thumb img slider
    --------------------------*/
    $('.pro-thumb-img-slider').owlCarousel({
      loop: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      items: 5,
      dots: false,
      margin: 25,
      nav: true,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 3
        },
        600: {
          items: 3
        },
        1000: {
          items: 5
        }
      }
    })

    /*-------------------------
      testimonial-active
    --------------------------*/

    $('.testimonial-active').owlCarousel({
      loop: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      items: 1,
      dots: false,
      nav: false,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })

    /*--- showlogin toggle function ----*/

    $( '#showlogin' ).on('click', function() {
      $( '#checkout-login' ).slideToggle(900);
    }); 

    /*--- showlogin toggle function ----*/
    $( '#showcoupon' ).on('click', function() {
      $( '#checkout_coupon' ).slideToggle(900);
    });

    /*--- showlogin toggle function ----*/
    $('#ship-box').on('click', function() {
      $('#ship-box-info').slideToggle(1000);
    });


    /*----------------------------
        youtube video
    ------------------------------ */
    $('.youtube-bg').YTPlayer({
      containment: '.youtube-bg',
      loop: true,
    });





    /* counterUp */
    $('.count').counterUp({
      delay: 10,
      time: 1000
    });

    /*-------------------------------------------
        03. scrollUp jquery active
    --------------------------------------------- */
    $.scrollUp({
      scrollText: '<i class="fa fa-angle-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });


    /*--
     Menu Sticky
    -----------------------------------*/
    var windows = $(window);
    var stickey = $(".style-6");

    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 1) {
        stickey.removeClass("stick");
      } else {
        stickey.addClass("stick");
      }
    });




    /*-- Product Quantity --*/
    $('.product-quantity2').append('<span class="dec qtybtn"><i class="fa fa-angle-left"></i></span><span class="inc qtybtn"><i class="fa fa-angle-right"></i></span>');
    $('.qtybtn').on('click', function() {
      var $button = $(this);
      var oldValue = $button.parent().find('input').val();
      if ($button.hasClass('inc')) {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
      }
      $button.parent().find('input').val(newVal);
    });


    /* Match Heigh */ 
    
    $(function() {
      $('.featured-product-grid').matchHeight();
    });  
    
    $(function() {
      $('.shop-grid-view').matchHeight();
    }); 
    
    $(function() {
      $('.blog-grid-view').matchHeight();
    });
    
    $(function() {
      $('.match-height-active').matchHeight();
    });
    
    /* Mega Menu */
   $('.mega-menu-li').parent('ul').addClass('mega-menu');
   
   $('.icon-search > a').removeAttr('href');
    
   /* preloader */
    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    }); 
    
    
    
    /*--------------------------	
	shop page manu dropdown	
---------------------------- */	
    $('.dropdown .option-btn').on('click', function(){
      if($(this).siblings('.dropdown-menu').hasClass('active')){
        $(this).siblings('.dropdown-menu').removeClass('active').slideUp();
        $(this).removeClass('active');
      }
      else{
        $('.dropdown .dropdown-menu').removeClass('active').slideUp();
        $('.dropdown .option-btn').removeClass('active');
        $(this).addClass('active');
        $(this).siblings('.dropdown-menu').addClass('active').slideDown();
      }
    });
    

  });

})(jQuery);



